import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=5982dc8c&scoped=true&"
import script from "./Panels.vue?vue&type=script&lang=ts&"
export * from "./Panels.vue?vue&type=script&lang=ts&"
import style0 from "./Panels.vue?vue&type=style&index=0&id=5982dc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982dc8c",
  null
  
)

export default component.exports